module.exports = __webpack_public_path__ + "gamechanger-bfaac00ac5602a306a3d.png";